document.querySelectorAll('.feat-button').forEach(button => {
    button.addEventListener('click', function() {
        tabVisible(button)
    });
});

if ( document.querySelector('.feat-button.active') != null ) {
    tabVisible(document.querySelector('.feat-button.active'))
}

function tabVisible(button) {
    const id = button.dataset.productId

    // Remove active class from all feat buttons
    document.querySelectorAll('.feat-button').forEach(otherButton => {
      otherButton.classList.remove('active');
    });

    document.querySelectorAll('[data-product-tab]').forEach(tab=> {
      tab.classList.remove('active');
    })

    // Add active class to the clicked button
    button.classList.add('active');

    document.querySelector(`[data-product-tab='${id}']`)?.classList.add('active')
}
